import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';
import { useTranslation } from 'react-i18next';

const ProcessChangeConfirmationModal = ({
  isOpen,
  onCloseClick,
  onConfirmClick,
  isLoading = false
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} size="md" centered fade backdrop="static">
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.AlertCircle size={60} className="text-orange" />
          <div className="fs-4 pt-2 text-orange">{t('areYouSure')}</div>
          <div className="fs-6 pt-2 text-center">{t('processChangeMessage')}</div>
        </div>
      </ModalBody>

      <ModalFooter className="justify-content-center">
        <Button onClick={onCloseClick} className="px-5 bg-transparent text-secondary">
          {t('cancel')}
        </Button>

        <Button
          onClick={onConfirmClick}
          className="d-flex justify-content-center align-items-center gap-2 px-5 bg-orange border-warning text-white">
          {t('confirm')}
          {isLoading && <Spinner size="sm" />}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ProcessChangeConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  onCloseClick: PropTypes.func.isRequired,
  onConfirmClick: PropTypes.func.isRequired
};

export default ProcessChangeConfirmationModal;
